(function ($) {
  /* More button in contact items */
  $('.js-toggle-collapsible').on('click', function (e) {
    e.preventDefault();
    var $button = $(this);
    var $content = $(this)
      .closest('.js-collapsible')
      .find('.js-collapsible-content');

    // Switch button text
    var $text_expanded = $button.data('text-expanded');
    var $text_collapsed = $button.data('text-collapsed');
    if ($button.hasClass('is-expanded')) {
      $text_collapsed && $button.text($text_collapsed);
    } else {
      $text_expanded && $button.text($text_expanded);
    }

    $button.toggleClass('is-expanded');
    $content.toggleClass('is-expanded');
    $content.slideToggle(500);
  });

  // people read more description
  $('.js-expand-button').on('click', function () {
    var $content = $(this).closest('.js-more-desc-content');
    var $shortExcerpt = $content.find('.js-short-excerpt');
    var $fullExcerpt = $content.find('.js-full-excerpt');
    var $button = $(this);

    if (!$fullExcerpt.hasClass('is-expanded')) {
      // close all other expanded descriptions
      $('.js-full-excerpt').removeClass('is-expanded');
      $('.js-short-excerpt').removeClass('is-hidden');
      $('.js-expand-button').removeClass('is-expanded');

      // open only current one
      $button.addClass('is-expanded');
      $fullExcerpt.addClass('is-expanded');
      $shortExcerpt.addClass('is-hidden');
    } else {
      $button.removeClass('is-expanded');
      $fullExcerpt.removeClass('is-expanded');
      $shortExcerpt.removeClass('is-hidden');
    }
  });

  // Show search bar
  $('body:not(.always-opened-search-bar) .js-toggle-search').on(
    'click',
    function (/*event*/) {
      var $searchBtns = $('.js-toggle-search');
      var $searchBar = $('.js-search-bar');
      var $searchInput = $searchBar.find('input');

      $searchBtns.toggleClass('is-toggled');
      $searchBar.toggleClass('is-toggled');
      // Also whole page overlay
      $('body').toggleClass('is-overlayed');

      // Close mobile nav when search bar is opened
      if ($('.js-toggle-nav').hasClass('is-toggled')) {
        $('.js-toggle-nav').trigger('click');
      }

      // Automatically focus on input
      if ($searchBar.hasClass('is-toggled')) {
        $searchInput.focus();
      } else {
        $searchInput.blur();
      }
    },
  );

  $('body.always-opened-search-bar .js-toggle-search').on(
    'click',
    function (/*event*/) {
      var $searchBar = $('.js-search-bar');
      var $searchInput = $searchBar.find('input');

      // Automatically focus on input
      $searchInput.focus();
    },
  );

  // Close search bar
  $('body:not(.always-opened-search-bar) .js-close-search').on(
    'click',
    function (/*event*/) {
      var $searchBtns = $('.js-toggle-search');
      var $searchBar = $('.js-search-bar');

      $searchBtns.removeClass('is-toggled');
      $searchBar.removeClass('is-toggled');
      $('body').removeClass('is-overlayed');
    },
  );
})(jQuery);
